<template>
  <v-form>
    <v-container>
      <div style="font-size: 20px;">{{ $route.params.storeName }}</div>

      <v-layout row wrap align-center>
        <v-flex xs12>
          <div style="height: 35px;"></div>
        </v-flex>

        <!-- <v-dialog v-model="updateDialog" max-width="500px">
          <v-card>
            <v-container>
              <v-card-title>修正</v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12>
                      <v-text-field
                        v-model="editedItem.stockQuantity"
                        label="物理在庫数"
                        type="number"
                        min="0"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="close">
                  <v-icon dark>arrow_back</v-icon>{{ $t('back-btn') }}
                </v-btn>
                <v-btn color="blue darken-1" flat @click="updateStocktakingDetail()">
                  <v-icon dark>save</v-icon>{{ $t('update-btn') }}
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-dialog>-->

        <v-layout row reverse>
          <v-flex xs2 sm2>
            <v-badge color="red" overlap>
              <template v-slot:badge>
                <span>{{ remarksList.length }}</span>
              </template>
              <v-btn align-center color="info" dark @click="openRemarksDialog()">備考の確認</v-btn>
            </v-badge>
            <v-dialog v-model="remarksDialog" width="500">
              <v-card>
                <v-card-title class="headline grey lighten-2" style="padding: 10px;">備考</v-card-title>

                <v-container>
                  <v-flex xs12 sm12 v-for="item in remarksList" :key="item.userName">
                    <v-textarea
                      outline
                      :label="item.userName + 'さんの追伸'"
                      readonly
                      :value="item.remarks"
                    ></v-textarea>
                  </v-flex>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="remarksDialog = false">閉じる</v-btn>
                  </v-card-actions>
                </v-container>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>

        <v-data-table
          :headers="headers"
          :items="warehouseStocktakingDetails"
          hide-actions
          class="elevation-1"
          :customFilter="customFilter"
          style="width: 100%; margin: 15px 0 0;"
          :no-data-text="$t('noTableDataAvailable')"
        >
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.header.text }}</span>
              </template>
              <span>{{ props.header.text }}</span>
            </v-tooltip>
          </template>
          <template v-slot:items="props">
            <!-- <tr @click="editItem(props.item)"> -->
            <tr>
              <td class="text-xs-left">{{ props.item.itemName }}</td>

              <td class="text-xs-right" v-if="props.item.preStock !== -1">{{ props.item.preStock }}</td>
              <td class="text-xs-right" v-else>データなし</td>
              <td class="text-xs-right">{{ props.item.stockQuantity }}</td>
              <td class="text-xs-right">{{ props.item.diffNum }}</td>
              <!-- <td class="text-xs-left">{{ props.item.createdUser }}</td> -->
            </tr>
          </template>
        </v-data-table>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm5>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/WarehouseStockManagement' }">
            <v-icon dark left>arrow_back</v-icon>{{ $t('back-btn') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm2></v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
import moment from 'moment-timezone'
export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    // this.selectCategory = {
    //   itemCategoryId: '#',
    //   itemCategoryName: '全て'
    // }

    // this.itemCategories.unshift(this.selectCategory)
    this.getStocktakingDetail()
  },
  methods: {
    getStocktakingDetail() {
      console.log('getStocktakingDetail')

      var weekNumber = this.$route.params.weekNumber

      console.log("weekNumber: ", weekNumber);

      var lastYearWeeks = moment()
        .subtract(1, 'year')
        .weeksInYear()

      console.log("lastYearWeeks: ", lastYearWeeks);

      var lastYear = ''
      var lastYearWeekNumber = 0

      // 比較用データの期間設定（4週間前のデータかを設定）
      var preWeekNumberUnit = 4

      // 比較用データが去年の場合
      if (weekNumber <= preWeekNumberUnit) {
        lastYearWeekNumber = lastYearWeeks - (weekNumber - preWeekNumberUnit)
        lastYear = moment()
          .subtract(1, 'year')
          .format('YYYY')
      }

      let request = {
        warehouseId: this.$route.params.warehouseId,
        weekNumber: weekNumber,
        lastYear: lastYear,
        lastYearWeekNumber: lastYearWeekNumber,
        preWeekNumber: weekNumber - preWeekNumberUnit,
        stocktakingYear: this.stocktakingYear
      }

      console.log("request: ", request);

      ServerApiCallService.getWarehouseStocktakingDetail(request)
        .then(response => {
          this.warehouseStocktakingDetails =
            response.data.warehouseStocktakingDetails

          this.remarksList = response.data.remarksList

          this.warehouseStocktakingDetails.forEach(item => {
            // TODO 初期理論在庫の設定
            item.diffNum = 'データなし'
            if (item.preStock !== -1) {
              item.diffNum = item.stockQuantity - item.preStock
            }
          })

          // 商品の表示順 商品カテゴリ、商品名
          this.warehouseStocktakingDetails.sort(function(a, b) {
            if (a.itemName > b.itemName) return 1
            if (a.itemName < b.itemName) return -1
            // a must be equal to b
            return 0
          })
          this.warehouseStocktakingDetails.sort(function(a, b) {
            if (a.itemCategoryId > b.itemCategoryId) return 1
            if (a.itemCategoryId < b.itemCategoryId) return -1
            // a must be equal to b
            return 0
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    customFilter(items, search) {
      console.log('custom filter')
      if (search.itemCategoryId === '#') {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.itemCategoryId === search.itemCategoryId) {
            return true
          } else {
            return false
          }
        })

        return filteringItems
      }
    },
    editItem(item) {
      console.log('editItem')

      // 過去のデータの場合、編集不可
      var now = moment().format('YYYYMM')
      var selectedMonth = moment(this.stocktakingMonth, 'YYYY-MM-DD').format(
        'YYYYMM'
      )
      if (now > selectedMonth) return

      this.editedItem = Object.assign({}, item)
      this.updateDialog = true
    },
    close() {
      this.updateDialog = false
    },
    //   updateStocktakingDetail() {
    //     console.log('saveStocktakingDetail')

    //     if (this.editedItem.stockQuantity < 0) {
    //       this.$parent.$parent.$parent.showErrorDialog(
    //         '正しい数字を入力してください'
    //       )
    //       return
    //     }

    //     let request = {
    //       stocktakingId: this.editedItem.stocktakingId,
    //       storeCode: this.editedItem.storeCode,
    //       itemCode: this.editedItem.itemCode,
    //       stocktakingMonth: this.editedItem.stocktakingMonth,
    //       stockQuantity: this.editedItem.stockQuantity
    //     }

    //     ServerApiCallService.updateStocktakingDetail(request)
    //       .then(response => {
    //         this.getStocktakingDetail()
    //       })
    //       .catch(error => {
    //         console.log('There was an error:', error.response)
    //         this.getStocktakingDetail()
    //       })
    //     this.updateDialog = false
    //   },
    openRemarksDialog() {
      this.remarksDialog = true
    }
  },
  data() {
    return {
      storeCode: this.$route.params.storeCode,
      stocktakingYear: this.$route.params.stocktakingYear,
      headers: [
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          sortable: false,
          width: '50%',
          fixed: false
        },
        {
          text: '4週前の在庫数',
          align: 'right',
          value: 'preStock',
          sortable: false,
          width: '10%',
          fixed: false
        },
        {
          text: '在庫数',
          align: 'right',
          value: 'stock',
          sortable: false,
          width: '10%',
          fixed: false
        },
        {
          text: '差',
          align: 'right',
          value: 'diffNum',
          width: '10%',
          sortable: false,
          fixed: false
        }
        // {
        //   text: '登録者',
        //   align: 'left',
        //   value: 'createdUser',
        //   sortable: false,
        //   width: '20%',
        //   fixed: false
        // }
      ],
      warehouseStocktakingDetails: [],
      updateDialog: false,
      remarksDialog: false,
      editedItem: '',
      remarksList: []
    }
  }
}
</script>
<style>
.active-class-name2 {
  background-color: pink;
}
</style>
